import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSiteConfig } from "@/contexts/SiteConfigContext";
import { useCopy } from "@/lib/copy";
import api from "@/lib/api";
import {
  Arrow, CarSprite, Gauge, ProfilePhoto, ProjectCard, StartLights, Tape, Transmitter, Wheel,
  formatDate, useReducedMotion,
} from "@/components/site/parts";

const SPEED_MODES = [
  { id: "slow", label: "SLOW", dur: "13s", speed: 18, color: "#3DDC84" },
  { id: "medium", label: "MEDIUM", dur: "7s", speed: 42, color: "#FFC83D" },
  { id: "fast", label: "FAST", dur: "2.8s", speed: 96, color: "#FF3D3D" },
];

const TRACK = "M200 80 H1000 A130 130 0 0 1 1000 340 H760 C680 340 660 250 600 250 C540 250 520 340 440 340 H200 A130 130 0 0 1 200 80 Z";

export default function Landing() {
  const { config } = useSiteConfig();
  const t = useCopy();
  const [projects, setProjects] = useState([]);
  const [skills, setSkills] = useState([]);
  const [posts, setPosts] = useState([]);
  const [timeline, setTimeline] = useState([]);

  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {});
    api.get("/skills").then(({ data }) => setSkills(data)).catch(() => {});
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {});
    api.get("/timeline").then(({ data }) => setTimeline(data)).catch(() => {});
  }, []);

  const current = timeline.find((e) => !e.end_date) || timeline[0];
  const years = config.years_experience || 0;

  return (
    <>
      {/* <Hero config={config} /> */}

      {/* <section aria-label="Stats" className="bx" style={{ paddingTop: 16 }}>
        <div className="g4">
          <Gauge pct={years / 10} value={`${years} YRS`} label={t("home.gauge_years")} color="var(--blue)" delay=".2s" />
          <Gauge pct={projects.length / 10} value={projects.length} label={t("home.gauge_projects")} color="#3DDC84" delay=".3s" />
          <Gauge pct={skills.length / 24} value={skills.length} label={t("home.gauge_skills")} color="#FFC83D" delay=".4s" />
          <Gauge pct={posts.length / 12} value={posts.length} label={t("home.gauge_posts")} color="#FF3D3D" delay=".5s" />
        </div>
      </section> */}

      {posts.length > 0 && (
        <section id="blog" aria-labelledby="blog-h" className="bx sec">
          <div className="card rv" style={{ overflow: "hidden" }}>
            <div className="sec-head padl" style={{ padding: "40px 44px 24px", margin: 0 }}>
              <div>
                <span className="kicker">{t("home.blog_kicker")}</span>
                <h2 id="blog-h" className="h-sec" style={{ fontSize: 48 }}>{t("home.blog_title")}</h2>
              </div>
              <Link to="/blog" className="btn btn-line" data-testid="section-cta-all-posts">{t("home.blog_cta")}</Link>
            </div>
            {posts.slice(0, 3).map((p, i) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="post-row" data-testid={`landing-post-${p.slug}`}>
                <span className="post-row-meta">
                  <span className="post-row-dot led-b" aria-hidden="true" />
                  {formatDate(p.published_at || p.created_at)}
                </span>
                <span className="post-row-title">{p.title}</span>
                {p.tags?.[0] && <span className="chip" style={{ height: 28 }}>{p.tags[0]}</span>}
              </Link>
            ))}
          </div>
        </section>
      )}

      <div className="bx" style={{ paddingTop: 16 }}><Tape /></div>

      <section id="about" aria-labelledby="about-h" className="bx" style={{ paddingTop: 16 }}>
        <div className="card rv padl split" style={{ padding: 48 }}>
          <ProfilePhoto name={config.name} src={config.profile_image_url} />
          <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
            <span className="kicker">{t("home.about_kicker")}</span>
            {/* <h2 id="about-h" className="h-sec">
              {t("home.about_title")} <span style={{ color: "var(--blue)" }}>{t("home.about_accent")}</span> {t("home.about_title_end")}
            </h2> */}
            {config.bio && <p className="lede">{config.bio}</p>}
            {t("home.about_extra") && <p className="lede">{t("home.about_extra")}</p>}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {current && <span className="chip">Currently at: {current.company}</span>}
              {projects[0] && <span className="chip">Latest project: {projects[0].title}</span>}
              {config.location && <span className="chip">Based in: {config.location}</span>}
            </div>
            <Link to="/about" className="btn btn-line" style={{ alignSelf: "flex-start" }}>{t("home.about_cta")} <Arrow /></Link>
          </div>
        </div>
      </section>

      {projects.length > 0 && (
        <section id="projects" aria-labelledby="projects-h" className="bx sec">
          <div className="sec-head rv">
            <div>
              <span className="kicker">{t("home.projects_kicker")}</span>
              <h2 id="projects-h" className="h-sec">
                {t("home.projects_title")} <span className="em">{t("home.projects_accent")}</span>
              </h2>
            </div>
            <p style={{ margin: 0, maxWidth: 360, fontSize: 15, lineHeight: 1.6, color: "#4A4F5A" }}>
              {t("home.projects_sub")}
            </p>
          </div>
          <div className="g3">
            {projects.slice(0, 3).map((p, i) => <ProjectCard key={p.id} project={p} index={i} />)}
          </div>
          {projects.length > 3 && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
              <Link to="/projects" className="btn btn-line">All {projects.length} projects <Arrow /></Link>
            </div>
          )}
        </section>
      )}

      {/* {skills.length > 0 && (
        <section id="skills" aria-labelledby="skills-h" className="bx sec">
          <div className="card-ink rv padl" style={{ padding: 44 }}>
            <div className="sec-head" style={{ marginBottom: 28 }}>
              <div>
                <span className="kicker on-dark">{t("home.skills_kicker")}</span>
                <h2 id="skills-h" className="h-sec" style={{ fontSize: 48 }}>{t("home.skills_title")}</h2>
              </div>
              <span className="hide-m"><Wheel /></span>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {skills.map((s) => (
                <span key={s.id} className="skill-tag">
                  {s.name}
                </span>
              ))}
            </div>
          </div>
        </section>
      )} */}

      {/* <ContactSection config={config} /> */}
    </>
  );
}

function Hero({ config }) {
  const t = useCopy();
  const [speed, setSpeed] = useState("medium");
  const reduced = useReducedMotion();
  const cur = SPEED_MODES.find((m) => m.id === speed);

  return (
    <section aria-labelledby="hero-h" className="bx" style={{ paddingTop: 16 }} data-testid="hero-section">
      <div className="hero rise d1">
        <div className="hero-top">
          <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 760 }}>
            <span className="mono" style={{ display: "inline-flex", flexWrap: "wrap", alignItems: "center", gap: 10, fontSize: 12, color: "#A3A8B4", textTransform: "uppercase" }}>
              <StartLights />
              {[config.role, config.location].filter(Boolean).join(" · ")}
            </span>
            <h1 id="hero-h" className="hero-h stretch">
              {t("home.hero_title")} <span className="em-y">{t("home.hero_accent")}</span>
            </h1>
            <p className="rise d5" style={{ margin: 0, maxWidth: 540, fontSize: 18, lineHeight: 1.6, color: "#B9BDC7" }}>
              {t("home.hero_sub") || config.hero_sub}
            </p>
            <div className="rise d6" style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              <Link to={config.hero_cta_primary_href || "/projects"} className="btn btn-y" data-testid="hero-cta-primary">{config.hero_cta_primary_label || "See my projects"} <Arrow /></Link>
              {config.hero_cta_secondary_label && config.hero_cta_secondary_href && (
                <Link to={config.hero_cta_secondary_href} className="btn btn-ghost" data-testid="hero-cta-secondary">{config.hero_cta_secondary_label}</Link>
              )}
              {config.resume_url && (
                <a href={config.resume_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost" data-testid="hero-resume-link">Résumé ↗</a>
              )}
            </div>
          </div>
          <div className="speed-control rise d4">
            <span className="mono" style={{ fontSize: 11, color: "#A3A8B4", textTransform: "uppercase" }}>{t("home.speed_label")}</span>
            <div role="group" aria-label="Choose an animation speed" className="speed-options">
              {SPEED_MODES.map((m) => (
                <button key={m.id} type="button" className="speed-option" aria-pressed={m.id === speed} onClick={() => setSpeed(m.id)}>
                  {m.label}
                </button>
              ))}
            </div>
            <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
              <span className="mono" style={{ fontSize: 11, color: "#A3A8B4" }}>SPEED</span>
              <span className="disp" aria-live="polite" style={{ fontSize: 30, fontWeight: 800, fontVariationSettings: "'wdth' 110", color: cur.color }}>
                {cur.speed}
                <span className="mono" style={{ fontSize: 12, color: "#A3A8B4", marginLeft: 4 }}>km/h</span>
              </span>
            </span>
          </div>
        </div>

        <svg className="hero-track" role="img" aria-label="A car driving around a track" viewBox="0 0 1200 420">
          <defs><path id="trk" d={TRACK} /></defs>
          <use href="#trk" fill="none" stroke="#F3F0E8" strokeWidth="66" />
          <use href="#trk" fill="none" stroke="#FF3D3D" strokeWidth="66" strokeDasharray="18 18" />
          <use href="#trk" fill="none" stroke="#2C3039" strokeWidth="56" />
          <use href="#trk" className="cline" fill="none" stroke="#5B606B" strokeWidth="2" strokeDasharray="22 22" />
          <g aria-hidden="true" fill="#FFFFFF">
            {[52, 60, 68, 76, 84, 92, 100].map((y, i) => <rect key={y} x={i % 2 ? 598 : 590} y={y} width="8" height="8" />)}
          </g>
          <text x="600" y="190" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="13" fill="#6E7380" letterSpacing="3">
            {(config.name || "").toUpperCase()}
          </text>
          <text x="600" y="214" textAnchor="middle" fontFamily="Geist Mono, monospace" fontSize="11" fill="#4A4F5A" letterSpacing="2">
            {cur.label} · {cur.speed} KM/H
          </text>
          {reduced ? (
            <g transform="translate(420 80)"><CarSprite /></g>
          ) : (
            SPEED_MODES.map((m) => (
              <g key={m.id} opacity={m.id === speed ? 1 : 0}>
                <animateMotion dur={m.dur} repeatCount="indefinite" rotate="auto">
                  <mpath href="#trk" />
                </animateMotion>
                <CarSprite flame={m.id === "fast"} />
              </g>
            ))
          )}
        </svg>
      </div>
    </section>
  );
}

export function ContactSection({ config, children }) {
  const t = useCopy();
  const socials = config.social_links || [];
  return (
    <section id="contact" aria-labelledby="contact-h" className="bx sec">
      <div className="contact-panel rv split">
        <div style={{ display: "flex", flexDirection: "column", gap: 26, position: "relative", minWidth: 0 }}>
          <span className="mono" style={{ fontSize: 12, color: "#DCE4FF", textTransform: "uppercase" }}>{t("contact.kicker")}</span>
          <h2 id="contact-h" className="contact-heading">
            {t("contact.title")} <span className="em-y">{t("contact.accent")}</span>
          </h2>
          <p style={{ margin: 0, maxWidth: 460, fontSize: 18, lineHeight: 1.6, color: "#E4EAFF" }}>{t("contact.sub")}</p>
          {config.email && (
            <a href={`mailto:${config.email}`} className="btn btn-ink" style={{ alignSelf: "flex-start", minHeight: 60, padding: "0 24px", fontSize: 18, borderRadius: 16, overflowWrap: "anywhere" }} data-testid="footer-email">
              {config.email}
              <Arrow size={16} color="#FFC83D" />
            </a>
          )}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {socials.map((s) => (
              <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost">{s.label} ↗</a>
            ))}
            {config.resume_url && (
              <a href={config.resume_url} target="_blank" rel="noopener noreferrer" className="btn btn-ghost">Résumé ↗</a>
            )}
          </div>
        </div>
        {children || <Transmitter />}
      </div>
    </section>
  );
}
